/* eslint-disable no-unused-vars */
import Highcharts from 'highcharts'
import { HighchartsReact } from 'highcharts-react-official'
import React from 'react'
import { Mask } from '../../../hooks/Mask'

const LineChart = ({ passedData, height }) => {
  function formatMonth(date) {
    const monthNames = [
      'jan',
      'fev',
      'mar',
      'abr',
      'mai',
      'jun',
      'jul',
      'ago',
      'set',
      'out',
      'nov',
      'dez',
    ]

    return monthNames[Number(date) - 1]
  }

  function formatDate(date) {
    const monthNames = [
      'jan',
      'fev',
      'mar',
      'abr',
      'mai',
      'jun',
      'jul',
      'ago',
      'set',
      'out',
      'nov',
      'dez',
    ]
    const [day, month, year] = date.split('/')
    return `${day} ${monthNames[Number(month) - 1]}`
  }

  const data = {
    categories: [
      'Jan',
      'Fev',
      'Mar',
      'Abr',
      'Mai',
      'Jun',
      'Jul',
      'Ago',
      'Set',
      'Out',
      'Nov',
      'Dez',
    ],
    series: [
      {
        name: 'Vendas',
        data: passedData.data,
      },
    ],
  }
  const options = {
    chart: {
      type: 'spline',
      height: height,
      spacingBottom: 0,
    },
    title: {
      text: 'Fluxo de vendas',
      align: 'left',

      style: {
        padding: 0,
        margin: 0,
        fontSize: '1.3em',
      },
    },
    xAxis: {
      categories: passedData.dates,
      lineColor: '#848080',

      labels: {
        formatter: function () {
          return formatMonth(this.value)
        },
      },
    },
    yAxis: {
      title: {
        text: 'Valor',
      },

      tickInterval: 250,

      min: 0,
      max: 2000,
    },
    tooltip: {
      backgroundColor: '#FFF',
      formatter: function () {
        const date = Highcharts.dateFormat('%m/%d/%Y', new Date(this.x))
        const value = Mask.money(this.y)
        return `<b>${date}</b><br>Vendas: <b>${value}</b>`
      },
    },
    legend: {
      align: 'right',
      verticalAlign: 'bottom',
      itemStyle: {
        fontWeight: 'bold',
      },
    },

    credits: {
      enabled: false,
    },
    series: data.series.map((series) => ({
      ...series,
      color: '#38D35C',
      lineWidth: 2,
    })),
  }

  return <HighchartsReact highcharts={Highcharts} options={options} />
}

export default LineChart
